const initialState = {
    pending: false,
    calibrationValues: [],
    page: 0,
    itemsCount: 0,
    pageCount: 0,
    error: null,
    filters: {active: 'ALL', itemsPerPage: 3, search: ''},
    selected: {}
};


const calibrationValuesReducer = (state = initialState, action) => {
    switch(action.type) {
        case 'GET_CALIBRATION_VALUES_PENDING':
            return {
                ...state,
                pending: true
            };
        case 'GET_CALIBRATION_VALUES_SUCCESS':
            return {
                ...state,
                pending: false,
                calibrationValues: action.calibrationValues,
                page: action.page,
                pageCount: action.pageCount,
                itemsCount: action.itemsCount
            };
        case 'GET_CALIBRATION_VALUES_ERROR':
            return {
                ...state,
                pending: false,
                error: action.error
            };
        // case 'GET_ALERT_MESSAGES_SUCCESS':
        //     return {
        //         ...state,
        //         pending: false,
        //         alertMessages: action.alertMessages
        //     }
        // case 'GET_ALERT_MESSAGES_ERROR':
        //     return {
        //         ...state,
        //         pending: false,
        //         error: action.error
        //     };
        case 'GET_CALIBRATION_MEASUREMENT_TYPES_SUCCESS':
            return {
                ...state,
                pending: false,
                calibrationMeasurementTypes: action.calibrationMeasurementTypes
            }
        case 'GET_CALIBRATION_MEASUREMENT_TYPES_ERROR':
            return {
                ...state,
                pending: false,
                error: action.error
            };
        case 'SELECT_CALIBRATION_VALUE':
            return {
                ...state,
                selected: action.selected
            };
        case 'ADD_CALIBRATION_VALUE_SUCCESS':
            return {
                ...state,
                pending: false
            };
        case 'ADD_CALIBRATION_VALUE_ERROR':
            return {
                ...state,
                pending: false,
                error: action.error
            };
        default:
            return state;
    }
}

export default calibrationValuesReducer
